import React from 'react';

import { ICustomizedShapeProps } from '../models/index.js';

export class CustomizedShape extends React.Component<ICustomizedShapeProps> {
	constructor(props: ICustomizedShapeProps) {
		super(props);
	}

	render() {
		const { cx, cy, fill, radius, borderColor, borderWeight } = this.props;
		return (
			<g>
				<circle cx={cx} cy={cy} r={radius} fill={fill} stroke={borderColor} strokeWidth={`${borderWeight}`} />
			</g>
		);
	}
}
